/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlimitedevents1Inputs */

const en_unlimitedevents1 = /** @type {(inputs: Unlimitedevents1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited events`)
};

const de_unlimitedevents1 = /** @type {(inputs: Unlimitedevents1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte Events`)
};

/**
* | output |
* | --- |
* | "Unlimited events" |
*
* @param {Unlimitedevents1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unlimitedevents1 = /** @type {((inputs?: Unlimitedevents1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlimitedevents1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlimitedevents1(inputs)
	return de_unlimitedevents1(inputs)
});
export { unlimitedevents1 as "unlimitedEvents" }